import { z } from 'zod';

import { encodedSignUpDataSchema } from '@nesso/identity-contracts/sign-up.models';

// A mangled or missing signUpData degrades to `undefined` rather than failing validateSearch: the
// page works without one, falling through to a plain /signup.
export const referralSearchSchema = z.object({
    signUpData: encodedSignUpDataSchema.optional().catch(undefined),
});
